import { BasicInfoFormData } from '@/types/forms/basicInfoForm'

export function calculateAgeValid(
    birthDayDate: Date,
    documentExpeditionDate: Date
): number {
    return (
        Math.abs(birthDayDate.getTime() - documentExpeditionDate.getTime()) /
        (1000 * 60 * 60 * 24 * 365.25)
    )
}

export const isUnderAge = (birthDate: Date): boolean => {
    const today = new Date()
    const age = Math.floor(
        (today.getTime() - birthDate.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
    )

    return age < 18
}

// Calculates age in full years
export function getAge(
    birthDate: Date,
    referenceDate: Date = new Date()
): number {
    let age = referenceDate.getFullYear() - birthDate.getFullYear()
    const month = referenceDate.getMonth() - birthDate.getMonth()

    if (
        month < 0 ||
        (month === 0 && referenceDate.getDate() < birthDate.getDate())
    ) {
        age--
    }

    return age
}

// Validates age according to document type and returns the error message or true
export function validateAgeByDocumentType(
    birthDate: Date,
    documentType: string,
    t: any,
    text: string
): true | string {
    const age = getAge(birthDate)

    if ((documentType === 'cc' || documentType === 'FS0010') && age < 18) {
        return t(`${text}.required.isOfLegalAge`)
    }

    if ((documentType === 'ti' || documentType === 'FS0020') && age >= 18) {
        return t(`${text}.required.isUnder18`)
    }

    if (age <= 13) {
        return t(`${text}.required.isOver13`)
    }

    return true
}

// Definición de las dependencias entre campos
export const FIELD_DEPENDENCIES = {
    // Dependencias de residencia
    countryExpedition: ['departmentExpedition', 'expeditionDocumentPlace'],
    departmentExpedition: ['expeditionDocumentPlace']
} as const

// Dependencias condicionales - solo se mantienen si se cumple la condición
export const CONDITIONAL_DEPENDENCIES = {
    countryExpedition: {
        field: 'expeditionDocumentPlace',
        condition: 'CO' // Solo Colombia
    }
    // Removido countryResidence -> zoneResidence porque son datos independientes
} as const

export function validateCity(data: BasicInfoFormData): BasicInfoFormData {
    if (
        data.expeditionDocumentPlace === null ||
        data.expeditionDocumentPlace === ''
    ) {
        data.expeditionDocumentPlace = 'BOGOTA'
    }

    return data
}
